/**
 * CSV zoals Excel in het Nederlands hem opent: `;` tussen de velden, komma als decimaalteken.
 * Het BOM-teken vooraan zet de download erbij (utils/download.ts). Puur.
 */

export type CsvCell = string | number | null

/** Een getal zoals de exports het als tekst schrijven: "-3", "12,50". Dat is geen formule. */
const NUMBER_TEXT = /^-?\d+(,\d+)?$/

/**
 * Eén tekstveld veilig maken. Tekst die met `=`, `+`, `-`, `@`, tab of regelterugloop begint, opent
 * Excel als formule (CSV-injectie: een klantnaam als `=HYPERLINK(…)`). Daar komt een `'` voor;
 * gewone getallen als "-3" blijven staan. Daarna aanhalingstekens rond tekst met `;`, `"` of een regeleinde.
 */
export function csvText(text: string): string {
  const safe = /^[=+\-@\t\r]/.test(text) && !NUMBER_TEXT.test(text) ? `'${text}` : text
  return /[;"\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe
}

const cell = (v: CsvCell) => {
  if (v === null) return ''
  return typeof v === 'number' ? String(v).replace('.', ',') : csvText(v)
}

export function toCsv(header: readonly string[], rows: readonly (readonly CsvCell[])[]): string {
  return [header, ...rows].map((r) => r.map(cell).join(';')).join('\r\n')
}
